import React from 'react';
import Modal from '../../../components/modal/modal';
import Icon from '../../../components/icon/icon';
import { WarningCircle } from '@phosphor-icons/react';
import '../style';

const CantEdit = ({ isOpen, onConfirm }) => {
  return (
    <div>
      <Modal 
        isOpen={isOpen}
        size={'regular'}
        className='cant-modal secondary-cta-hidden'
        primaryText={'Okay, got it!'}
        onClickPrimaryCta={onConfirm}>
        <div className='flex flex-col gap-8'>
          <Icon
            type='circle'
            className='icon-circle'
          >
            <WarningCircle
              size={32}
              color="#D92D20"
            />
          </Icon>
          <div className='heading-24'>You can’t edit your Payout details when you have a live event</div>
        </div>
      </Modal>
    </div>
  )
}

export default CantEdit